'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Text(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      translate = _ref.translate;

  return _react2.default.createElement(
    'svg',
    {
      width: size,
      height: size,
      viewBox: '0 0 28 28',
      version: '1.1',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    },
    _react2.default.createElement(
      'g',
      {
        transform: translate ? 'translate(0 0)' : 'translate(-2.000000, -2.000000)',
        stroke: 'none',
        strokeWidth: 1,
        fill: 'none',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('rect', { fill: '#F2F2F2', x: 2, y: 2, width: 28, height: 28, rx: 4 }),
      _react2.default.createElement(
        'g',
        { transform: 'translate(7.000000, 8.000000)', fill: '#878E91' },
        _react2.default.createElement('path', { d: 'M16.356 2H.644C.288 2 0 1.552 0 1s.288-1 .644-1h15.712c.356 0 .644.448.644 1s-.288 1-.644 1m0 5H.644C.288 7 0 6.552 0 6s.288-1 .644-1h15.712c.356 0 .644.448.644 1s-.288 1-.644 1m0 5H.644C.288 12 0 11.552 0 11s.288-1 .644-1h15.712c.356 0 .644.448.644 1s-.288 1-.644 1m0 5H.644C.288 17 0 16.552 0 16s.288-1 .644-1h15.712c.356 0 .644.448.644 1s-.288 1-.644 1' })
      )
    )
  );
}

Text.propTypes = {
  translate: _propTypes2.default.bool,
  size: _propTypes2.default.number
};

exports.default = Text;